// src/modules/components/reports/calls/SummaryCard.js
import React from "react";
import {
  Card,
  CardContent,
  Box,
  Typography,
  useTheme,
} from "@mui/material";

const SummaryCard = ({ title, value, secondaryValue, icon: Icon, color = "primary" }) => {
  const theme = useTheme();

  const colorMap = {
    primary: theme.palette.primary,
    success: theme.palette.success,
    error: theme.palette.error,
    warning: theme.palette.warning,
    info: theme.palette.info,
  };

  const selectedColor = colorMap[color] || colorMap.primary;

  return (
    <Card
      sx={{
        height: "100%",
        boxShadow: 3,
        borderLeft: `4px solid ${selectedColor.main}`,
        transition: "transform 0.2s",
        "&:hover": {
          transform: "translateY(-4px)",
        },
      }}
    >
      <CardContent sx={{ display: "flex", alignItems: "center" }}>
        <Box
          sx={{
            backgroundColor: selectedColor.light,
            borderRadius: "50%",
            width: 56,
            height: 56,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mr: 2,
            color: selectedColor.contrastText,
          }}
        >
          <Icon fontSize="medium" />
        </Box>
        <Box>
          <Typography variant="subtitle1" color="textSecondary" gutterBottom>
            {title}
          </Typography>
          <Typography variant="h4" component="div" fontWeight="bold">
            {value || 0}
          </Typography>
          {secondaryValue && (
            <Typography variant="body2" color="textSecondary">
              {secondaryValue}
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default SummaryCard;